import { render, staticRenderFns } from "./publicLinksBlock.vue?vue&type=template&id=320acc4a&scoped=true&"
import script from "./publicLinksBlock.vue?vue&type=script&lang=js&"
export * from "./publicLinksBlock.vue?vue&type=script&lang=js&"
import style0 from "./publicLinksBlock.vue?vue&type=style&index=0&id=320acc4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320acc4a",
  null
  
)

export default component.exports